/**
 * Resolves links to blog posts.
 */
export const blogPostLinkResolver = (url: string) => `/resources/the-weelhouse${url}`;
